import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Radar } from 'lucide-react';
import { api } from '../api';
import { usePortal } from '../PortalAuth';
import { canSee } from '../shells/nav';
import { fmtDay } from './useDashboardData';

export default function MonitoringEventsCard({ design }) {
  const { user } = usePortal();
  const [items, setItems] = useState(null);
  const allowed = canSee(user, 'monitoring') && !(user.services_disabled || []).includes('monitoring');
  useEffect(() => { if (allowed) api.get('/monitoring/recent').then((r) => setItems(r.data)).catch(() => setItems([])); }, [allowed]);
  if (!allowed || items === null) return null;
  const rosso = design === 'rosso';
  return (
    <div className={`${rosso ? 'rsd-card' : 'exd-card'} mt-4`} data-testid="dashboard-monitoring-events">
      <div className="flex items-start justify-between mb-3">
        {rosso ? <div><p className="rsd-kicker">Monitoraggio</p><h4>Ultimi eventi</h4></div> : <h3 className="exd-h3 !mb-0">Ultimi eventi di monitoraggio</h3>}
        <Link to="/portal/monitoraggio" className="text-xs hover:underline mt-1 whitespace-nowrap shrink-0 ml-3" style={{ color: rosso ? '#E0463F' : '#8E1B1B' }} data-testid="dashboard-all-events">Vedi tutti</Link>
      </div>
      {items.length === 0 ? <p className="text-sm opacity-60 flex items-center gap-2"><Radar size={15} />Nessun evento: ti avviseremo qui appena un'azienda monitorata cambia.</p> : items.map((e) => (
        <Link key={e.id} to="/portal/monitoraggio" data-testid={`dashboard-event-${e.id}`}
          className={`flex items-start gap-3 py-2.5 px-2 -mx-2 rounded-sm border-l-2 ${e.severe ? 'border-[#E5484D] bg-[#E5484D]/[0.08]' : 'border-transparent'}`}>
          {e.severe ? <AlertTriangle size={15} className="mt-0.5 shrink-0 text-[#E5484D]" /> : <Radar size={15} className="mt-0.5 shrink-0 opacity-50" />}
          <span className="flex-1 min-w-0">
            <span className="block text-sm truncate"><b>{e.company_name}</b>{e.unread && <span className="ml-2 text-[10px] uppercase tracking-wider" style={{ color: e.severe ? '#E5484D' : '#C9A227' }}>Nuovo</span>}</span>
            <span className={`block text-xs ${e.severe ? 'text-[#E5484D] font-medium' : 'opacity-70'}`}>{e.severe && 'Grave · '}{e.rule}{(e.old_value != null || e.new_value != null) ? ` · ${e.old_value ?? '—'} → ${e.new_value ?? '—'}` : ''}</span>
          </span>
          <span className="text-xs opacity-60 shrink-0">{fmtDay(e.event_date)}</span>
        </Link>
      ))}
    </div>
  );
}
